export default "__VITE_ASSET__COz8CQb6__"